<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import { EventBus } from './EventBus'
export default {
  name: "App",

  data: () => ({
    //
  }),
  mounted() {
    EventBus.$on('alert-success', this.alertSuccess)
    EventBus.$on('alert-error', this.alertError)
    EventBus.$on('alert-warning', this.alertWarning)
    EventBus.$on('alert-error-login', this.alertErrorLogin)
    EventBus.$on('alert-warning-login', this.alertWarningLogin)
  },
  methods: {
    alertSuccess(html = '', timer = 4000) {
      this.$swal({
        icon: 'success',
        html,
        showCloseButton: true,
        showConfirmButton: false,
        timer: timer,
        customClass: {
          htmlContainer: 'alert-text'
        }
      })
    },
    alertError(html = '', timer = 4000) {
      this.$swal({
        icon: 'error',
        html,
        showCloseButton: true,
        showConfirmButton: false,
        timer: timer,
        customClass: {
          htmlContainer: 'alert-text'
        }
      })
    },
    alertWarning(html = '', timer = 4000) {
      this.$swal({
        icon: 'warning',
        html,
        showCloseButton: true,
        showConfirmButton: false,
        timer: timer,
        customClass: {
          htmlContainer: 'alert-text'
        }
      })
    },
    alertErrorLogin(html = '', timer = 4000) {
      this.$swal({
        icon: 'error',
        showIcon: false,
        html: `
          <div class="custom-icon-wrapper">
              <svg class="custom-error-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 
                9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 
                0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"/></svg>
            <div class="custom-alert-text">
            ${html}
            </div>
          </div>
        `,
        showCloseButton: true,
        showConfirmButton: false,
        timer: timer,
        didOpen: () => {
          const closeBtn = document.querySelector('.swal2-close');
          if (closeBtn) {
            closeBtn.innerHTML = `
              <svg class="custom-close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" 
                  style="width: 20px; height: 20px; fill: red;">
                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 
                210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 
                0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 
                45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 
                32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 
                342.6 150.6z"/>
              </svg>
            `;
          }
        },
        customClass: {
          popup: 'custom-alert-card',
          htmlContainer: 'custom-alert-text',
          icon: 'custom-alert-icon',
        }
      })
    },
    alertWarningLogin(html = '', timer = 4000) {
      this.$swal({
        icon: 'warning',
        showIcon: false,
        html: `
          <div class="custom-icon-wrapper">
            <svg class="custom-warning-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <title>alert-circle-outline</title>
              <path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,
              2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" /></svg>
            <div class="custom-alert-text">
            ${html}
            </div>
          </div>
        `,
        showCloseButton: true,
        showConfirmButton: false,
        timer: timer,
        didOpen: () => {
          const closeBtn = document.querySelector('.swal2-close');
          if (closeBtn) {
            closeBtn.innerHTML = `
              <svg class="custom-close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" 
                  style="width: 20px; height: 20px; fill: red;">
                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 
                210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 
                0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 
                45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 
                32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 
                342.6 150.6z"/>
              </svg>
            `;
          }
        },
        customClass: {
          popup: 'custom-alert-card',
          htmlContainer: 'custom-alert-text',
          icon: 'custom-alert-icon',
        }
      })
    }
  },
  beforeDestroy() {
    EventBus.$off('alert-success')
    EventBus.$off('alert-warning')
    EventBus.$off('alert-error')
    EventBus.$off('alert-warning-login')
    EventBus.$off('alert-error-login')

  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Thai&display=swap');

/* ================================== alert css ============================ */
.alert-text {
  font-family: 'Noto Sans Thai', sans-serif;
  color: black !important;
}

/*======================= Sweet Alert confirm pop-up css ==========================*/
.sweet-confirm-text {
  font-family: 'Noto Sans Thai', sans-serif;
  color: black !important;
  font-size: 21px;
  padding-bottom: 35px;
  padding-top: 30px;
}

.sweet-confirm-card {
  padding-bottom: 15px !important;
}

.sweet-confirm-btn {
  font-family: 'Noto Sans Thai', sans-serif;
  background-color: rgb(60, 86, 147) !important;
}

.sweet-confirm-btn:focus {
  box-shadow: none !important;
}

.sweet-confirm-cancel-btn {
  font-family: 'Noto Sans Thai', sans-serif;
  background-color: rgb(154, 179, 209) !important;
  width: 74px;
}

.background-img {
  position: relative;
  background-color: #F5FBFD;
  height: 100%;
  width: 100%;
  z-index: 0;
}

.background-img::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("/Vector.png");
  background-position: bottom left;
  background-repeat: no-repeat;
  background-size: 100%;
  background-attachment: fixed;
  opacity: 0.1;
  z-index: -1;
}

.background-img::after {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("/Vector2.png");
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: 70%;
  background-attachment: fixed;
  opacity: 0.2;
  z-index: -1;
}

.custom-alert-text {
  font-family: 'Noto Sans Thai', sans-serif;
  color: #274C77 !important;
  font-size: 20px;
  font-weight: 600;
  display: flex !important;
  align-items: center;
}

.custom-alert-card {
  border-radius: 28px;
  box-shadow: 0px 2.85px 10px 0px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  width: 560px;
  max-width: 90%;
  min-height: 225px;
}

.custom-alert-card .swal2-icon {
  display: none !important;
}

.custom-alert-card .swal2-close {
  box-shadow: none !important;
}

.custom-close-icon {
  width: 26px !important;
  height: 26px !important;
  fill: #CCCCCC !important;
}

.custom-close-icon:hover {
  fill: #F44336 !important;
}

.custom-warning-icon,
.custom-error-icon {
  fill: #F44336 !important;
  margin-bottom: 10px;
}

.custom-warning-icon {
  width: 100px !important;
  height: 100px !important;
}

.custom-error-icon {
  width: 90px !important;
  height: 90px !important;
}

/*========================================*/

@media only screen and (max-width:600px) {

  /*css for mobile screen*/
  .display-pc-only {
    display: none !important;
  }
}

/*==========================================*/

@media only screen and (min-width: 600px) {

  /*css for pc screen*/
  .display-mobile-only {
    display: none !important;
  }
}
</style>
